import { assignArray } from "../assignArray";
import { assignSet } from "../assignSet";
import { assignMap } from "../assignMap";
import { assignKeys } from "../assignKeys";
import { assignSymbols } from "../assignSymbols";
import { isSet, isMap } from "../typeMatchers";

/**
 * Delegate to assign keys and symbols
 */
export function assign(target: any, source: any): any {
	if (Array.isArray(target)) {
		assignArray(target, source);
		return target;
	}
	if (isSet(target)) {
		assignSet(target, source);
		return target;
	}

	if (isMap(target) && isMap(source)) {
		assignMap(target, source);
		return target;
	}

	target = Object(target);
	source = Object(source);

	assignKeys(target, source);
	assignSymbols(target, source);

	return target;
}
